






































import { Component,Prop, Vue } from 'vue-property-decorator';
import YouTubePlayer from 'youtube-player';

@Component
export default class About extends Vue {
  /**
   *@see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
   */
  mounted():void {
    let  player1:any  = YouTubePlayer('player-1',{
     videoId: 'uP5VZbfrO1c',
    // height: '360',
    // width: '640',
    // events: {
    //   'onReady': onPlayerReady,
    //   'onStateChange': onPlayerStateChange
    // }
    }) ;
    // let element = document.getElementById('player-1');
    // element.style.width='100%';
  }
}
